/* app.js — Interface : délègue l'analyse au Worker, rend le modèle normalisé
 * reçu, gère les exports. */
(function () {
  'use strict';

  var F = window.MediaFormat;
  var K = window.MediaFindings;

  var drop = document.getElementById('drop');
  var emptyState = document.getElementById('emptyState');
  var dropOverlay = document.getElementById('dropOverlay');
  var fileInput = document.getElementById('fileInput');
  var statusEl = document.getElementById('status');
  var resultsEl = document.getElementById('results');
  var tracksEl = document.getElementById('tracks');
  var smpte = document.getElementById('smpte');

  var worker = null;
  var jobId = 0;
  var current = { model: null, raw: null, file: null, summary: '' };

  /* ---------- Worker ---------- */
  function ensureWorker() {
    if (worker) return worker;
    worker = new Worker(new URL('./workers/analyze.worker.js', import.meta.url), { type: 'module' });
    worker.onmessage = function (e) {
      var m = e.data || {};
      if (m.jobId !== undefined && m.jobId !== jobId) return; // résultat périmé
      if (m.type === 'status') {
        if (m.stage === 'engine') setStatus('Chargement du moteur d’analyse…');
        else if (m.stage === 'analyze') setStatus('Analyse de « ' + m.name + ' »…');
      } else if (m.type === 'result') {
        onResult(m.model, m.raw);
      } else if (m.type === 'error') {
        onError(m.error);
      }
    };
    worker.onerror = function (ev) { onError(ev.message || 'Erreur du Worker d’analyse.'); };
    return worker;
  }

  function analyze(file, skipped) {
    var b = document.getElementById('batch'); if (b) b.hidden = true; // mode fichier unique
    setHasFile(true);
    current = { model: null, raw: null, file: file, summary: '', sentence: '', diags: [] };
    jobId++;
    var w = ensureWorker();
    setBusy(true);
    resultsEl.classList.remove('visible');
    var suffix = skipped
      ? ' — ' + skipped + (skipped > 1 ? ' autres fichiers ignorés' : ' autre fichier ignoré')
      : '';
    setStatus('Préparation…' + suffix);
    w.postMessage({ type: 'analyze', file: file, jobId: jobId, cover: true });
  }

// Test réel de lecture, ajouté aux valeurs mesurées.
  function probeBrowser(model) {
    var P = window.MediaCapabilitiesProbe;
    if (!P) return Promise.resolve(model);
    var video = document.createElement('video');
    return P.probe(model, {
      mediaCapabilities: navigator.mediaCapabilities,
      canPlayType: function (mime) { return video.canPlayType(mime); }
    }).then(function (r) {
      model.measured = (model.measured || []).concat(r.values);
      model.absent = (model.absent || []).concat(r.absent);
      return model;
    }, function () { return model; });
  }

  function onResult(model, raw) {
    var job = jobId;
    probeBrowser(model).then(function () { if (job === jobId) showResult(model, raw); });
  }

  // Accueil ou résultat : une seule des deux à l'écran.
  function setHasFile(on) {
    document.body.classList.toggle('has-file', !!on);
    if (emptyState) emptyState.hidden = !!on;
  }

  // L'accueil disparaît dès qu'il y a une fiche, un lot ou une comparaison.
  function refreshEmpty() {
    setHasFile(!!current.model ||
      (window.Batch && window.Batch.isActive()) ||
      (window.Compare && window.Compare.isActive()));
  }

  function showResult(model, raw) {
    current.model = model;
    current.raw = raw;
    var sentence = window.MediaSummary.describe(model);
    var diags = window.MediaDiagnostics.diagnose(model, null);
    current.sentence = sentence;
    current.diags = diags;
    render(model, sentence);
    if (window.ProfilesUI) window.ProfilesUI.apply(model); // évalue le profil sélectionné, puis les écarts
    if (window.Integrity) window.Integrity.setFile(current.file);
    if (window.Structure) window.Structure.setFile(current.file);
    if (window.Measure) window.Measure.setFile(current.file);
    setStatus('');
    setBusy(false);
    var f = window.Routes && window.Routes.takeFocus();
    if (f) focusBlock(f);
  }

  function currentReport() { return window.ProfilesUI ? window.ProfilesUI.report() : null; }

  function onError(detail) {
    setBusy(false);
    var msg;
    if (/wasm|memory|instantiate|abort/i.test(detail)) {
      msg = 'Le moteur d’analyse n’a pas pu s’initialiser dans ce navigateur.';
    } else if (/read|NotReadable|permission/i.test(detail)) {
      msg = 'Le fichier n’a pas pu être lu depuis le disque.';
    } else {
      msg = 'Ce fichier n’a pas pu être analysé (format non reconnu ou fichier endommagé).';
    }
    setStatus(msg + ' Détail : ' + detail, true);
  }

  /* ---------- Rendu (depuis le modèle normalisé) ---------- */
  function render(model, sentence) {
    var c = model.container;
    document.getElementById('fname').textContent = current.file ? current.file.name : (c.fileName || '');
    document.getElementById('fsize').textContent = F.fmt.bytes(c.fileSize) || '';
    var nb = model.tracks.length;
    document.getElementById('fanalyzed').textContent =
      nb + ' piste' + (nb > 1 ? 's' : '') + ' média + infos conteneur';

    document.getElementById('synthese').textContent = sentence || '';
    renderIdentity(model);
    selectTab('main');
    renderGaps(null); // rendu à nouveau quand le profil sélectionné a été évalué
    tracksEl.innerHTML = detailCards(model);
    resultsEl.classList.add('visible');
    resultsEl.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------- Onglet « Détails techniques » : une carte par piste ---------- */

  // Chiffres mis en avant : [libellé, valeur, unité].
  function kpisOf(kind, t) {
    function n(v) { return v == null ? null : v; }
    var list = [];
    if (kind === 'general') {
      list = [['Durée', F.fmt.duration(t.duration), null], ['Débit', F.fmt.bitrate(t.overallBitRate), null],
        ['Taille', F.fmt.bytes(t.fileSize), null]];
    } else if (kind === 'video') {
      list = [['Définition', t.width && t.height ? t.width + ' × ' + t.height : null, 'px'],
        ['Cadence', t.frameRate != null ? String(t.frameRate).replace('.', ',') : null, 'i/s'],
        ['Débit', F.fmt.bitrate(t.bitRate), null],
        ['Profondeur', n(t.bitDepth), 'bits']];
    } else if (kind === 'audio') {
      list = [['Canaux', t.channelLayout && t.channelLayout.friendly ? t.channelLayout.friendly : n(t.channels), null],
        ['Échantillonnage', t.samplingRate != null ? String(t.samplingRate / 1000).replace('.', ',') : null, 'kHz'],
        ['Débit', F.fmt.bitrate(t.bitRate), null],
        ['Profondeur', n(t.bitDepth), 'bits']];
    }
    return list.filter(function (x) { return x[1] != null && x[1] !== ''; });
  }

  function kpisHtml(kpis) {
    if (!kpis.length) return '';
    return '<div class="kpi-row">' + kpis.map(function (k) {
      var v = String(k[1]);
      var unit = k[2] || '';
      return '<div class="kpi"><span class="kpi-lbl">' + F.esc(k[0]) + '</span>' +
        '<span class="kpi-val">' + F.esc(v) + (unit ? ' <span class="kpi-unit">' + F.esc(unit) + '</span>' : '') + '</span></div>';
    }).join('') + '</div>';
  }

  function detailCards(model) {
    var blocks = F.view(model);
    var subjects = [model.container].concat(model.tracks.filter(function (t) { return t.kind !== 'menu'; }));
    var cards = blocks.map(function (b, i) {
      var t = subjects[i] || {};
      var measured = b.rows.some(function (r) { return r.origin === 'measured'; });
      var rows = b.rows.length
        ? '<dl class="kv">' + b.rows.map(function (r) {
            return '<dt>' + F.esc(r.k) + '</dt><dd>' + F.esc(r.v) +
              (r.origin ? ' <span class="origin ' + F.esc(r.origin) + '">' + F.esc(K.ORIGINS[r.origin]) + '</span>' : '') + '</dd>';
          }).join('') + '</dl>'
        : '<p class="card-sub">Aucune caractéristique clé pour cette piste.</p>';
      return '<section class="card track ' + F.esc(cssKind(b.kind)) + '">' +
        '<header class="card-head"><h3>' + F.esc(b.title) + '</h3>' +
        '<span class="epi epi-declared">déclaré</span>' +
        (measured ? '<span class="epi epi-measured">mesuré</span>' : '') + '</header>' +
        (b.sub ? '<p class="card-sub">' + F.esc(b.sub) + '</p>' : '') +
        kpisHtml(kpisOf(b.kind, t)) + rows + '</section>';
    });
    var cover = F.coverImg(model);
    if (cover) cards.push('<section class="card cover-card"><header class="card-head"><h3>Pochette</h3></header>' + cover + '</section>');
    var chapters = F.chaptersHtml(model);
    if (chapters) cards.push('<section class="card chapters-card">' + chapters + '</section>');
    return cards.join('');
  }

  // Carte « Identité » : le fichier en six lignes, à côté du verdict.
  function renderIdentity(model) {
    var c = model.container;
    var v = model.tracks.filter(function (t) { return t.kind === 'video'; })[0];
    var rows = [
      ['Conteneur', c.format],
      ['Durée', F.fmt.duration(c.duration)],
      ['Taille', F.fmt.bytes(c.fileSize)],
      ['Débit global', F.fmt.bitrate(c.overallBitRate)],
      ['Image', v ? F.trackLabel(v) : null],
      ['Pistes', Object.keys(model.counts).filter(function (k) { return k !== 'menu' && k !== 'general'; })
        .map(function (k) { return model.counts[k] + ' × ' + (K.TRACK_KIND_LABELS ? K.TRACK_KIND_LABELS[k] || k : k); }).join(', ')]
    ];
    document.getElementById('identityBody').innerHTML = rows.filter(function (r) { return r[1]; })
      .map(function (r) { return '<dt>' + F.esc(r[0]) + '</dt><dd>' + F.esc(r[1]) + '</dd>'; }).join('');
  }

  function cssKind(kind) {
    return { general: 'General', video: 'Video', audio: 'Audio', text: 'Text',
      menu: 'Menu', image: 'Image', other: 'Other' }[kind] || 'Other';
  }

  // En-tête (titre, décompte, présentation) puis contenu.
  function block(id, cls, title, count, lede, body) {
    return '<section class="block ' + cls + '" id="' + id + '" aria-labelledby="' + id + 'Title">' +
      '<header class="block-head"><h3 class="block-title" id="' + id + 'Title">' + F.esc(title) +
      (count != null ? ' <span class="block-count">' + count + '</span>' : '') + '</h3>' +
      (lede ? '<p class="block-lede">' + F.esc(lede) + '</p>' : '') + '</header>' +
      '<div class="block-body">' + body + '</div></section>';
  }

  // Métadonnées personnelles, avec un lien vers leur retrait s'il existe.
  function renderPrivacy(model, cleanKey) {
    var v = F.privacyView(model);
    var personal = v.items.filter(function (it) { return it.personal; }).length;
    var body = v.empty ? '<p class="ok">' + F.esc(v.empty) + '</p>'
      : '<dl class="facts privacy-dl">' + v.items.map(function (it) {
        return '<dt>' + F.esc(it.label) + '</dt><dd>' + F.esc(it.value) +
          (it.personal ? ' <span class="origin personal">' + F.esc(K.LABELS.personalBadge) + '</span>' : '') + '</dd>';
      }).join('') + '</dl>' +
      (cleanKey ? '<div class="gap-act"><button type="button" class="act tiny" data-goto-fix="' + F.esc(cleanKey) + '">' +
        F.esc(K.LABELS.removePersonal) + '</button></div>' : '');
    document.getElementById('privacyMain').innerHTML =
      block('privacy', 'privacy', v.title, personal || null, v.empty ? null : v.note, body);
  }

  function gapItemHtml(it, L, AU) {
    function row(k, v) { return v ? '<dt>' + F.esc(k) + '</dt><dd>' + F.esc(v) + '</dd>' : ''; }
    var fixKey = AU ? AU.fixKeyOfGap(it.index) : null;
    var facts = row(L.expected, it.expected) + row(L.observed, it.observed.join(' ; ')) +
      (it.proof ? '<dt>' + F.esc(L.proof) + '</dt><dd>' + F.esc(it.proof.text) +
        ' <button type="button" class="linkbtn" data-reveal="' + it.proof.offset + '">' + F.esc(L.showInStructure) + '</button></dd>' : '');
    var act = fixKey
      ? '<button type="button" class="act tiny" data-goto-fix="' + F.esc(fixKey) + '">' + F.esc(L.fixIt) + ' →</button>' +
        '<span class="gap-corr">' + F.esc(it.correction || '') + '</span>'
      : it.correction ? '<span class="gap-corr"><span class="fix-k">' + F.esc(L.correction) + '</span> ' + F.esc(it.correction) + '</span>' : '';
    return '<li class="gap sev-' + F.esc(it.severity) + '" id="gap-' + it.index + '">' +
      '<div class="gap-head"><span class="badge ' + F.esc(it.severity) + '">' + F.esc(it.severityLabel) + '</span>' +
      '<h5 class="gap-title">' + F.esc(it.title) + '</h5></div>' +
      '<p class="gap-tags"><span class="tag">' + F.esc(it.subject) + '</span>' + (it.domain ? '<span class="tag">' + F.esc(it.domain) + '</span>' : '') + '</p>' +
      (facts ? '<dl class="facts">' + facts + '</dl>' : '') +
      '<p class="gap-why"><span class="fix-k">' + F.esc(L.why) + '</span>' + F.esc(it.explanation) + '</p>' +
      (it.confidence ? '<p class="gap-conf"><span class="fix-k">' + F.esc(L.confidence) + '</span> ' + F.esc(it.confidence) + '</p>' : '') +
      (act ? '<div class="gap-act">' + act + '</div>' : '') + '</li>';
  }

  // Ce qui a été réellement examiné : structure lue, mesures faites.
  function domainScope(d) {
    var S = K.DOMAIN_SCOPE;
    if (d === 'integrity') {
      if (current.structure && current.structure.supported) return S.integrity;
      if (current.model.survey) return S.integritySurvey;
      return S.integrityNone;
    }
    var group = K.MEASURED_GROUPS[d];
    if (group && (current.model.measured || []).some(function (v) { return group.indexOf(v.property) >= 0; })) {
      return S[d + 'Measured'];
    }
    return S[d];
  }

  // Rangement des écarts, retenu d'une visite à l'autre.
  var LS_ORDER = 'meta-lab.gapOrder';
  var order = 'priority';
  try { if (localStorage.getItem(LS_ORDER) === 'domain') order = 'domain'; } catch (_) {}

  // Sommaire, écarts (par priorité ou par domaine), profil, corrections, vie privée.
  function renderGaps(report) {
    var el = document.getElementById('gaps');
    var ov = document.getElementById('overview');
    if (!current.model) { el.innerHTML = ''; ov.innerHTML = ''; return; }
    var gaps = K.collect({ diagnostics: current.diags || [], report: report, model: current.model });
    var view = F.gapsView(gaps, current.model, !!report);
    var L = view.labels;
    var items = [].concat.apply([], view.groups.map(function (g) { return g.items; }));
    var AU = window.ActionsUI;
    if (AU) AU.prepare(gaps, current.model, current.file ? current.file.name : current.model.container.fileName, items, current.file);

    var list;
    if (order === 'domain') {
      list = Object.keys(K.DOMAINS).map(function (d) {
        var inDomain = items.filter(function (it) { return gaps[it.index].domain === d; });
        var scope = domainScope(d);
        return '<div class="gap-group-wrap"><h4 class="gap-group">' + F.esc(K.DOMAINS[d]) + (inDomain.length ? ' <span class="n">' + inDomain.length + '</span>' : '') + '</h4>' +
          '<p class="gap-scope">' + F.esc(scope) + '</p>' +
          (inDomain.length ? '<ul class="gap-list">' + inDomain.map(function (it) { return gapItemHtml(it, L, AU); }).join('') + '</ul>'
            : scope === K.DOMAIN_SCOPE.integrityNone ? '' : '<p class="gap-none">' + F.esc(L.noGapInDomain) + '</p>') + '</div>';
      }).join('');
    } else if (!view.total) {
      list = '<p class="ok">' + F.esc(view.empty) + '</p>';
    } else {
      list = view.groups.map(function (g) {
        return '<div class="gap-group-wrap"><h4 class="gap-group ' + g.priority + '">' + F.esc(g.label) + ' <span class="n">' + g.items.length + '</span></h4><ul class="gap-list">' +
          g.items.map(function (it) { return gapItemHtml(it, L, AU); }).join('') + '</ul></div>';
      }).join('');
    }
    var toggle = '<div class="order" role="group" aria-label="' + F.esc(L.orderBy) + '"><span>' + F.esc(L.orderBy) + '</span>' +
      ['priority', 'domain'].map(function (o) {
        return '<button type="button" data-order="' + o + '" aria-pressed="' + (o === order) + '">' +
          F.esc(o === 'priority' ? L.byPriority : L.byDomain) + '</button>';
      }).join('') + '</div>';
    el.innerHTML = block('gapsBlock', 'gaps', view.title, view.total || null, L.gapsLede, toggle + list);

    var nFix = AU ? AU.count() : 0;
    var rest = items.filter(function (it) { return !(AU && AU.fixKeyOfGap(it.index)); }).length;
    var fixBody = nFix ? AU.blockBody() : '<p class="ok">' + F.esc(L.nothingToCorrect) + '</p>';
    if (nFix && rest) fixBody += '<p class="block-foot">' + F.esc(K.fill(L.notCorrectable, { count: rest })) + '</p>';
    document.getElementById('fixesSlot').innerHTML = block('fixes', 'fixes', L.fixesTitle, nFix || null, null, fixBody);

    var clean = gaps.map(function (g, i) { return g.type === 'personal-metadata' && AU ? AU.fixKeyOfGap(i) : null; }).filter(Boolean)[0];
    renderPrivacy(current.model, clean);
    renderOverview(view, report, nFix);
  }

  // Sommaire : chaque entrée mène à son bloc.
  function renderOverview(view, report, nFix) {
    var counts = {};
    view.groups.forEach(function (g) { counts[g.priority] = g.items.length; });
    var P = F.privacyView(current.model);
    var personal = P.items.filter(function (it) { return it.personal; }).length;
    var chips = K.PRIORITY_ORDER.map(function (p) {
      return '<a href="#gapsBlock" class="ov-chip ' + p + (counts[p] ? '' : ' zero') + '">' +
        '<b>' + (counts[p] || 0) + '</b> ' + F.esc(K.PRIORITIES[p]) + '</a>';
    });
    var V = report ? report.verdict : null;
    chips.push('<a href="#conformity" class="ov-chip usage">' + F.esc(K.LABELS.usageTitle) + ' : <b>' +
      F.esc(V ? V.label : '—') + '</b></a>');
    chips.push('<a href="#fixes" class="ov-chip">' + '<b>' + nFix + '</b> ' + F.esc(K.LABELS.fixesChip) + '</a>');
    chips.push('<a href="#privacy" class="ov-chip' + (personal ? ' personal' : '') + '">' + F.esc(P.title) + ' : <b>' + personal + '</b></a>');
    document.getElementById('overview').innerHTML = chips.join('');
    var badge = document.getElementById('fbadge');
    if (badge) {
      var worst = counts.fix ? 'fix' : counts.check ? 'check' : counts.optional ? 'optional' : 'none';
      badge.className = 'mini-badge ' + worst;
      badge.title = worst === 'none' ? K.LABELS.emptyWithoutProfile : K.PRIORITIES[worst];
    }
  }

  function focusBlock(id) {
    selectTab('main');
    var t = document.getElementById({ gaps: 'gapsBlock', privacyMain: 'privacy' }[id] || id);
    if (t) t.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------- Onglets Résultat / Détails techniques ---------- */
  var tabs = { main: document.getElementById('tabMain'), details: document.getElementById('tabDetails') };
  var panels = { main: document.getElementById('panelMain'), details: document.getElementById('panelDetails') };
  function selectTab(name, focus) {
    Object.keys(tabs).forEach(function (k) {
      var on = k === name;
      tabs[k].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[k].tabIndex = on ? 0 : -1;
      panels[k].hidden = !on;
    });
    if (focus) tabs[name].focus();
  }
  Object.keys(tabs).forEach(function (k) {
    tabs[k].addEventListener('click', function () { selectTab(k); });
    tabs[k].addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft' || e.key === 'Home' || e.key === 'End') {
        e.preventDefault();
        selectTab(k === 'main' ? 'details' : 'main', true);
      }
    });
  });

  if (window.ProfilesUI) window.ProfilesUI.onReport(renderGaps);
  if (window.ActionsUI) window.ActionsUI.bind(document.getElementById('panelMain'));
  // D'un écart à sa correction et retour ; la cible est brièvement signalée.
  function jump(id) {
    var t = document.getElementById(id);
    if (!t) return;
    t.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'center' });
    t.classList.remove('flash'); void t.offsetWidth; t.classList.add('flash');
    var f = t.querySelector('select, input, button'); if (f) f.focus({ preventScroll: true });
  }
  document.getElementById('panelMain').addEventListener('click', function (e) {
    var b = e.target.closest('[data-goto-fix], [data-goto-gap]');
    if (!b) return;
    if (b.hasAttribute('data-goto-fix')) jump(window.ActionsUI.anchorOf(b.getAttribute('data-goto-fix')));
    else jump('gap-' + b.getAttribute('data-goto-gap'));
  });
  document.getElementById('overview').addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    e.preventDefault(); // l'ancre ne doit pas changer de mode
    focusBlock(a.getAttribute('href').slice(1));
  });
  // Les anomalies de la structure explorée remplacent celles du survol.
  if (window.Structure) window.Structure.onResult(function (result) {
    if (!current.model) return;
    current.structure = result;
    current.diags = window.MediaDiagnostics.diagnose(current.model, result);
    renderGaps(currentReport());
  });
  document.getElementById('gaps').addEventListener('click', function (e) {
    var o = e.target.closest('[data-order]');
    if (o) {
      order = o.getAttribute('data-order');
      try { localStorage.setItem(LS_ORDER, order); } catch (_) {}
      renderGaps(currentReport());
      return;
    }
    var b = e.target.closest('[data-reveal]');
    if (b && window.Structure) { selectTab('details'); window.Structure.reveal(+b.getAttribute('data-reveal')); }
  });

  /* ---------- Exports ---------- */
  function downloadBlob(data, mime, name) {
    var blob = new Blob([data], { type: mime });
    var a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = name;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(function () { URL.revokeObjectURL(a.href); }, 5000);
  }

  document.getElementById('btnJson').addEventListener('click', function () {
    if (!current.raw) return;
    downloadBlob(JSON.stringify(current.raw, null, 2), 'application/json',
      (current.file ? current.file.name : 'analyse') + '.mediainfo.json');
  });

  document.getElementById('btnReport').addEventListener('click', function () {
    if (!current.model || !window.MediaReport) return;
    var rep = window.ProfilesUI ? window.ProfilesUI.evaluateWith(window.ProfilesUI.currentId(), current.model) : null;
    var html = window.MediaReport.buildFileReport({
      fileName: current.file ? current.file.name : 'analyse',
      fileSize: current.file ? current.file.size : current.model.container.fileSize,
      model: current.model,
      sentence: current.sentence || window.MediaSummary.describe(current.model),
      diags: current.diags || [],
      report: rep,
      digest: window.Integrity ? window.Integrity.digest() : null,
      generatedAt: fmtNow()
    });
    downloadBlob(html, 'text/html;charset=utf-8', (current.file ? current.file.name : 'analyse') + '.rapport.html');
  });

  function fmtNow() { try { return new Date().toLocaleString('fr-FR'); } catch (_) { return ''; } }

  document.getElementById('btnCopy').addEventListener('click', function () {
    if (!current.model) return;
    var text = window.MediaReport.buildSummaryText({
      sentence: current.sentence, diags: current.diags || [], report: currentReport(),
      model: current.model, fileName: current.file ? current.file.name : null
    });
    function ok() { flashStatus('Résumé copié dans le presse-papiers.'); }
    function ko() {
      downloadBlob(text, 'text/plain;charset=utf-8',
        (current.file ? current.file.name : 'analyse') + '.resume.txt');
      setStatus('La copie automatique n’est pas disponible — le résumé a été téléchargé en fichier texte.');
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(ok, function () { fallbackCopy(text) ? ok() : ko(); });
    } else { fallbackCopy(text) ? ok() : ko(); }
  });

  function fallbackCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      var done = document.execCommand('copy'); ta.remove();
      return done;
    } catch (_) { return false; }
  }

  document.getElementById('btnReset').addEventListener('click', function () {
    jobId++;
    current = { model: null, raw: null, file: null, summary: '', sentence: '', diags: [] };
    resultsEl.classList.remove('visible');
    document.getElementById('synthese').textContent = '';
    document.getElementById('gaps').innerHTML = '';
    document.getElementById('fixesSlot').innerHTML = '';
    document.getElementById('overview').innerHTML = '';
    document.getElementById('privacyMain').innerHTML = '';
    tracksEl.innerHTML = '';
    if (window.ProfilesUI) window.ProfilesUI.apply(null);
    if (window.Integrity) window.Integrity.reset();
    if (window.Structure) window.Structure.reset();
    if (window.Measure) window.Measure.reset();
    fileInput.value = '';
    setStatus(''); setBusy(false);
    refreshEmpty();
    window.scrollTo({ top: 0, behavior: prefersReduced() ? 'auto' : 'smooth' });
  });

  /* ---------- États & interactions ---------- */
  var statusTimer = null;
  function setStatus(msg, isError) {
    if (statusTimer) { clearTimeout(statusTimer); statusTimer = null; }
    statusEl.textContent = msg;
    statusEl.classList.toggle('error', !!isError);
  }
  function flashStatus(msg) {
    setStatus(msg);
    statusTimer = setTimeout(function () { statusTimer = null; setStatus(''); }, 2500);
  }
  function setBusy(b) {
    if (smpte) smpte.classList.toggle('busy', !!b);
    document.body.classList.toggle('analyzing', !!b);
    if (drop) drop.setAttribute('aria-busy', b ? 'true' : 'false');
  }
  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  drop.addEventListener('click', function () { fileInput.click(); });
  drop.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fileInput.click(); }
  });
  // Dépôt partagé : le mode courant décide du sort des fichiers.
  function received(list) {
    if (!list || !list.length) return;
    var files = Array.prototype.slice.call(list);
    if (window.Routes) window.Routes.handleFiles(files);
    else if (files.length > 1 && window.Batch) window.Batch.start(files);
    else analyze(files[0]);
  }
  fileInput.addEventListener('change', function () { received(fileInput.files); fileInput.value = ''; });
  ['dragenter', 'dragover'].forEach(function (ev) {
    drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('over'); });
  });
  ['dragleave', 'drop'].forEach(function (ev) {
    drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('over'); });
  });
  drop.addEventListener('drop', function (e) { received(e.dataTransfer && e.dataTransfer.files); });

  // Dépôt n'importe où : un voile s'affiche pendant le survol.
  var dragDepth = 0;
  function overlay(on) { if (dropOverlay) dropOverlay.hidden = !on; }
  document.addEventListener('dragenter', function (e) {
    if (!e.dataTransfer || e.dataTransfer.types.indexOf('Files') < 0) return;
    dragDepth++; overlay(true);
  });
  document.addEventListener('dragover', function (e) { if (dropOverlay && !dropOverlay.hidden) e.preventDefault(); });
  document.addEventListener('dragleave', function () { if (--dragDepth <= 0) { dragDepth = 0; overlay(false); } });
  document.addEventListener('drop', function (e) {
    if (!e.dataTransfer || !e.dataTransfer.files || !e.dataTransfer.files.length) return;
    e.preventDefault(); dragDepth = 0; overlay(false);
    received(e.dataTransfer.files);
  });
  var chooseBtn = document.getElementById('chooseFile');
  if (chooseBtn) chooseBtn.addEventListener('click', function () { fileInput.click(); });
  var build = document.getElementById('buildNote');
  if (build && window.MediaRules) {
    build.textContent = 'moteur v' + window.MediaRules.ENGINE_VERSION +
      ' · build ' + __BUILD__ + ' · 100 % local';
  }

  window.App = {
    analyze: function (file) { analyze(file); },
    probeBrowser: probeBrowser,
    // Fichier déjà analysé (lot, comparaison). opts.tab : 'main' | 'details'.
    showDetail: function (entry, opts) {
      if (!entry || !entry.model) return;
      current = { file: entry.file, model: entry.model, raw: entry.raw, summary: '',
        sentence: entry.summary, diags: entry.diags };
      render(entry.model, entry.summary);
      if (window.ProfilesUI) window.ProfilesUI.apply(entry.model);
      if (window.Integrity) window.Integrity.setFile(entry.file);
      if (window.Structure) window.Structure.setFile(entry.file);
      if (opts && opts.tab) selectTab(opts.tab);
    },
    hasFile: function () { return !!current.model; },
    addMeasured: function (values) {
      if (!current.model || !values || !values.length) return;
      var keep = (current.model.measured || []).filter(function (v) {
        return !values.some(function (n) {
          return n.property === v.property && n.subject.kind === v.subject.kind && n.subject.ordinal === v.subject.ordinal;
        });
      });
      current.model.measured = keep.concat(values);
      // les détecteurs lisent ces valeurs : un constat peut apparaître ou tomber
      current.diags = window.MediaDiagnostics.diagnose(current.model, current.structure);
      render(current.model, current.sentence);
      if (window.ProfilesUI) window.ProfilesUI.apply(current.model);
      selectTab('main');
    },
    refreshEmpty: refreshEmpty,
    flash: flashStatus,
    // Retour à l'analyse depuis la comparaison.
    rerender: function () {
      if (!current.model) return;
      resultsEl.classList.add('visible');
      renderGaps(currentReport());
    },
    focus: focusBlock,
    hide: function () { resultsEl.classList.remove('visible'); }
  };
})();
